import { NoticePage } from './NoticePage';

export default NoticePage;
